const transformEmptyStringToUndefined = (cv, ov) => (ov === '' ? undefined : cv);

export default transformEmptyStringToUndefined;